// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__Q5T55","footerGrid":"Footer_footerGrid__J3zUe","title":"Footer_title__o3sfG","socialLinks":"Footer_socialLinks__VDbnR","team":"Footer_team__HsB_D"};